import { LoadingButton } from "@mui/lab";
import {  useState } from "react";
import {  useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";
import NoDataCard from '../../../../../../components/no-data-card';
import { Box } from '@mui/material';
import { selectFollowCycle,selectCoaInfo } from '../../../../../slices/common';

// import { coaFormValues } from '../../../../../components/features/CoaForm/Common';
// import { hasAuthority } from '../../../../../../utils/authorities';
import COAPrint from '../../../../Manufacturer/COAPrint';

const DownloadCOAForm = ({patientData}) => {
    // const [allPrintData, setAllPrintData] = useState({});
    // const inBoundId = patientData?.inbond_patient?.id;
    // const feasibilityId = patientData?.feasibility_assessments?.id;
    // const printTimeoutAllRef = useRef(null);
    // const printContentAllRef = useRef(null);
    // const isInBoundPrint = ['logistics-management', 'superadmin', 'editor', 'warehouse', 'quality-check', 'project-manager']?.includes(LoginData?.role_slug)
    const currentCycle = useSelector(selectFollowCycle);
    //  const allInitialSteps = useSelector(selectAllInitialSteps);
    //  const bmr_permissions = LoginData?.bmr_permissions || [];
    // const [initialValues, setInitialValues] = useState(coaFormValues);
    const [coaPrintModal, setCoaPrintModal] = useState(false)
     const checkCOAForm =  useSelector(selectCoaInfo)


    //    const canShowQcRemark = useMemo(() => {
    //         const steps = allInitialSteps?.find(op => op.slug === "qc-testing")?.status
    //         return (
    //        (steps == 4 || steps == 5 || steps == 3 || steps == 2) && (hasAuthority(["quality-analyst-approve"], bmr_permissions) || (hasAuthority(["quality-control-lead-approval"], bmr_permissions) || hasAuthority(["quality-control-lead-reject"], bmr_permissions)))
    //         );
    //     }, [allInitialSteps, bmr_permissions]);

    //      const canShowQaRemarks = useMemo(() => {
    //         const steps = allInitialSteps?.find(op => op.slug === "qc-testing")?.status
    //         const qaSteps = allInitialSteps?.find(op => op.slug === "qa-review")?.status
    //         return (
    //        hasAuthority(["quality-approval-approve-form"], bmr_permissions) && (steps == 2 && (qaSteps == 0 || qaSteps == 2 || qaSteps == 3))
    //         );
    //     }, [allInitialSteps, bmr_permissions]);

    //     const fieldSet = useMemo(() => [
    //   { section: "Certificate of Analysis for NexCAR19TM" },

    //   {
    //     label: "Product Name",
    //     type: "text",
    //     name: "product_name",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "Batch Number",
    //     type: "text",
    //     name: "batch_no",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "Patient ID",
    //     type: "text",
    //     name: "immunoact_patient_id",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "MFG Date",
    //     type: "date",
    //     name: "mfg_date",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Expiry Date",
    //     type: "date",
    //     name: "expired_at",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Storage Conditions",
    //     type: "text",
    //     name: "storage_condition",
    //     placeholder: "Enter Storage Conditions",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Specification No.",
    //     type: "text",
    //     name: "specification_no",
    //     placeholder: "Enter Specification No.",
    //     disabled: true,
    //     noQuery: true,
    //     required: true,
    //     col: 2,
    //   },

    //   {
    //     label: "RCL",
    //     type: "text",
    //     name: "rcl_qpcr",
    //     placeholder: "Enter RCL",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "Sterility",
    //     type: "text",
    //     name: "sterility_culture_method_bactec",
    //     placeholder: "Enter Sterility",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "Multiplex Viral test",
    //     type: "text",
    //     name: "multiplex_viral_test_pcr",
    //     placeholder: "Enter Multiplex Viral test",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 3,
    //   },
    //   {
    //     label: "Mycoplasma",
    //     type: "text",
    //     name: "mycoplasma_pcr",
    //     placeholder: "Enter Mycoplasma",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Appearance (Milky, No Aggregates)",
    //     type: "text",
    //     name: "appearance",
    //     placeholder: "Enter Appearance",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "CAR surface expression",
    //     type: "number",
    //     name: "car_surface_expression_flow_cytometry",
    //     placeholder: "Enter CAR surface expression",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Cell viability",
    //     type: "number",
    //     name: "cell_viability_dye_exclusion_method",
    //     placeholder: "Enter Cell viability",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "CD19 + viable cell detection",
    //     type: "number",
    //     name: "cd19_viable_cell_detection_flow_cytometry",
    //     placeholder: "Enter CD19 + viable cell detection",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Detection of magnetic beads",
    //     type: "text",
    //     name: "detection_of_magnetic_beads_microscope",
    //     placeholder: "Enter Detection of magnetic beads",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Endotoxin level",
    //     type: "text",
    //     name: "endotoxin_level",
    //     placeholder: "Enter Endotoxin level",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Vector copy number - VCN",
    //     type: "number",
    //     name: "vector_copy_number_vcn_qpcr",
    //     placeholder: "Enter Vector copy number-VCN",
    //     // disabled: disabledAll,
    //     // noQuery: coaFormApproved,
    //     isResolve: ["quality-check"],
    //     required: true,
    //     col: 2,
    //   },
    //   {
    //     label: "Remarks",
    //     type: "textarea",
    //     name: "remarks",
    //     placeholder: "Enter Remarks",
    //     // disabled: disabledAll,
    //     noQuery: true,
    //     required: true,
    //     col: 1,
    //   },

    //   ...(canShowQcRemark
    //     ? [{
    //         label: "Lead Remarks",
    //         type: "textarea",
    //         name: "lead_remarks",
    //         placeholder: "Enter Lead Remarks",
    //         // disabled: !enableFields,
    //         noQuery: true,
    //         required: true,
    //         col: 1,
    //       }]
    //     : []),

    //   ...(canShowQaRemarks
    //     ? [{
    //         label: "Remarks (QA)",
    //         type: "textarea",
    //         name: "qa_remarks",
    //         placeholder: "Enter Remarks",
    //         // disabled: enableQAFields,
    //         noQuery: true,
    //         required: true,
    //         col: 1,
    //       }]
    //     : []),
    // ], [

    // ]);
    

    const handleCoaPrint = () => {
        setCoaPrintModal(true)
    }

    return (
        <>

            {currentCycle?.coa_forms_id
                // && inBoundId && feasibilityId
                ?
                (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <LoadingButton
                                type="button"
                                size="small"
                                onClick={handleCoaPrint}
                                className="!w-[100px] "
                            >
                                Print
                            </LoadingButton>
                        </Box>
                        {(checkCOAForm && currentCycle?.coa_forms_id) && (
                             <COAPrint
                                    open={coaPrintModal}
                                    onClose={() => {
                                        setCoaPrintModal(false);
                                    }}
                                    printData={checkCOAForm}
                                    patientInfo={{...patientData,batch_no:currentCycle?.batch_no}}
                                    isVisible={true}
                                />
                        )}
                    </>
                ) : (
                    <div >
                        <NoDataCard heading="No Data to Display" />
                    </div>
                )
            }
        </>
    );

}

export default DownloadCOAForm